import { render, staticRenderFns } from "./TodayPostTrip.vue?vue&type=template&id=0ac6ebbe&scoped=true&"
import script from "./TodayPostTrip.vue?vue&type=script&lang=js&"
export * from "./TodayPostTrip.vue?vue&type=script&lang=js&"
import style0 from "./TodayPostTrip.vue?vue&type=style&index=0&id=0ac6ebbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac6ebbe",
  null
  
)

export default component.exports